import { FC } from "react";
import { DynamicResources, GameState } from "../types";
import { formatMoney, formatNumber } from "../utils/formatting";
import { getResourceSprite } from "../utils/tileOverlayUtils";
import Sprite from "./Sprite";

export interface ResourceDisplayProps {
  dynamicResources: DynamicResources;
  gameState: GameState;
}

const ResourceDisplay: FC<ResourceDisplayProps> = ({
  dynamicResources,
  gameState,
}) => {
  const getValueColor = (value: number): string => {
    return value <= 0 ? "text-red-500" : "text-white";
  };

  return (
    <div className="text-white font-mono text-med">
      {/* Line 1: Dynamic Resources */}
      <div className="flex gap-6 mb-2">
        Income:
        <span className="flex items-center ">
          <Sprite
            filename="/images/resources_20.png"
            {...getResourceSprite("money")}
            width={20}
            height={20}
            className="inline-block"
          />
          Coins:{" "}
          <span className={getValueColor(dynamicResources.money)}>
            {formatMoney(dynamicResources.money)}
          </span>
        </span>
        <span className="flex items-center ">
          <Sprite
            filename="/images/resources_20.png"
            {...getResourceSprite("fuel")}
            width={20}
            height={20}
            className="inline-block"
          />
          Fuel:{" "}
          <span className={getValueColor(dynamicResources.fuel)}>
            {formatNumber(dynamicResources.fuel)}
          </span>
        </span>
        <span className="flex items-center ">
          <Sprite
            filename="/images/resources_20.png"
            {...getResourceSprite("food")}
            width={20}
            height={20}
            className="inline-block"
          />
          Food:{" "}
          <span className={getValueColor(dynamicResources.food)}>
            {formatNumber(dynamicResources.food)}
          </span>
        </span>
        <span className="flex items-center ">
          <Sprite
            filename="/images/resources_20.png"
            {...getResourceSprite("ore")}
            width={20}
            height={20}
            className="inline-block"
          />
          Ore:{" "}
          <span className={getValueColor(dynamicResources.ore)}>
            {formatNumber(dynamicResources.ore)}
          </span>
        </span>
      </div>

      {/* Line 2: Game State */}
      <div className="flex gap-6">
        <span className="flex items-center ">
          Bank :{" "}
          <Sprite
            filename="/images/resources_20.png"
            {...getResourceSprite("money")}
            width={20}
            height={20}
            className="inline-block"
          />
          <span className="text-yellow-400">
            {formatMoney(gameState.money)}
          </span>
        </span>
        {gameState.seenResources.size > 0 && (
          <span>
            Resources:{" "}
            {Array.from(gameState.seenResources).join(", ") || "None"}
          </span>
        )}
      </div>
    </div>
  );
};

export default ResourceDisplay;
